// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  BatchGetData,
  BatchGetDefinitionsData,
  BatchGetDefinitionsErrors,
  BatchGetDefinitionsResponses,
  BatchGetErrors,
  BatchGetPSetsByDefData,
  BatchGetPSetsByDefErrors,
  BatchGetPSetsByDefResponses,
  BatchGetPSetsData,
  BatchGetPSetsErrors,
  BatchGetPSetsResponses,
  BatchGetResponses,
  ChangesetPSetsAsyncData,
  ChangesetPSetsAsyncErrors,
  ChangesetPSetsAsyncResponses,
  ChangesetPSetsData,
  ChangesetPSetsErrors,
  ChangesetPSetsResponses,
  CreateDefinitionData,
  CreateDefinitionErrors,
  CreateDefinitionResponses,
  CreateLibraryData,
  CreateLibraryErrors,
  CreateLibraryResponses,
  DeleteDefinitionData,
  DeleteDefinitionErrors,
  DeleteDefinitionResponses,
  DeleteLibraryData,
  DeleteLibraryErrors,
  DeleteLibraryResponses,
  DeletePSetData,
  DeletePSetErrors,
  DeletePSetResponses,
  GetChangesetStatusData,
  GetChangesetStatusErrors,
  GetChangesetStatusResponses,
  GetDefinitionData,
  GetDefinitionErrors,
  GetDefinitionResponses,
  GetDefinitionVersionBySchemaData,
  GetDefinitionVersionBySchemaErrors,
  GetDefinitionVersionBySchemaResponses,
  GetDefinitionVersionData,
  GetDefinitionVersionErrors,
  GetDefinitionVersionResponses,
  GetLibraryData,
  GetLibraryErrors,
  GetLibraryPolicyData,
  GetLibraryPolicyErrors,
  GetLibraryPolicyResponses,
  GetLibraryResponses,
  GetPSetData,
  GetPSetErrors,
  GetPSetResponses,
  GetPSetVersionData,
  GetPSetVersionErrors,
  GetPSetVersionResponses,
  LandingPageData,
  LandingPageResponses,
  ListDefinitionsData,
  ListDefinitionsErrors,
  ListDefinitionsResponses,
  ListDefinitionVersionsData,
  ListDefinitionVersionsErrors,
  ListDefinitionVersionsResponses,
  ListPSetChangesByDefData,
  ListPSetChangesByDefErrors,
  ListPSetChangesByDefResponses,
  ListPSetChangesByLibData,
  ListPSetChangesByLibErrors,
  ListPSetChangesByLibResponses,
  ListPSetsByDefData,
  ListPSetsByDefErrors,
  ListPSetsByDefResponses,
  ListPSetsByLibData,
  ListPSetsByLibErrors,
  ListPSetsByLibResponses,
  ListPsetsByLinkData,
  ListPsetsByLinkErrors,
  ListPsetsByLinkResponses,
  ListPSetsOldData,
  ListPSetsOldErrors,
  ListPSetsOldResponses,
  ListPSetVersionsData,
  ListPSetVersionsErrors,
  ListPSetVersionsResponses,
  MeData,
  MeErrors,
  MeResponses,
  PsetsSyncData,
  PsetsSyncErrors,
  PsetsSyncResponses,
  SubscribeData,
  SubscribeErrors,
  SubscribeResponses,
  UpdateLibraryPolicyData,
  UpdateLibraryPolicyErrors,
  UpdateLibraryPolicyResponses,
  UpdatePSetData,
  UpdatePSetErrors,
  UpdatePSetResponses,
  UpsertDefinitionData,
  UpsertDefinitionErrors,
  UpsertDefinitionResponses,
  UpsertLibraryData,
  UpsertLibraryErrors,
  UpsertLibraryResponses,
  ValidatePsetsData,
  ValidatePsetsErrors,
  ValidatePsetsResponses,
  XdomainData,
  XdomainResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Landing page
 *
 * The Service landing web page containing API usage information and useful links.
 */
export const landingPage = <ThrowOnError extends boolean = false>(
  options?: Options<LandingPageData, ThrowOnError>
) =>
  (options?.client ?? client).get<LandingPageResponses, unknown, ThrowOnError>({
    url: '/',
    ...options,
  });

/**
 * (Experimental) CORS xdomain proxy
 *
 * The experimental xdomain proxy to avoid the pre-flight requests (CORS) in web apps that are using this public API. A static resource that can be used to proxy all API calls to this service to avoid pre-flight requests. On your web page add the following script. It's important to include XDomain before any other library. When XDomain loads, XHook replaces the current window.XMLHttpRequest. So if another library saves a reference to the original window.XMLHttpRequest and uses that, XHook won't be able to intercept those requests.
 * ```javascript <script src="https://unpkg.com/xdomain@0.8.2/dist/xdomain.min.js" slave="https://pset-api.connect.trimble.com/v1/proxy.html"></script> ```
 * After that, any XHR to https://pset-api.connect.trimble.com origin mentioned in the `slave` property will automagically work without a pre-flight request
 */
export const xdomain = <ThrowOnError extends boolean = false>(
  options?: Options<XdomainData, ThrowOnError>
) =>
  (options?.client ?? client).get<XdomainResponses, unknown, ThrowOnError>({
    url: '/proxy.html',
    ...options,
  });

/**
 * Subscribe
 *
 * Get information about subscribing to notification websocket.
 */
export const subscribe = <ThrowOnError extends boolean = false>(
  options?: Options<SubscribeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    SubscribeResponses,
    SubscribeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/subscribe',
    ...options,
  });

/**
 * Me
 *
 * Get information about the user bearer token belongs to.
 */
export const me = <ThrowOnError extends boolean = false>(
  options?: Options<MeData, ThrowOnError>
) =>
  (options?.client ?? client).get<MeResponses, MeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/me',
    ...options,
  });

/**
 * GetLibraryPolicy.
 *
 * Get the access control policy attached to the library.
 */
export const getLibraryPolicy = <ThrowOnError extends boolean = false>(
  options: Options<GetLibraryPolicyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLibraryPolicyResponses,
    GetLibraryPolicyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/policy',
    ...options,
  });

/**
 * UpdateLibraryPolicy.
 *
 * This operation allows to update an access control policy attached to the library.
 */
export const updateLibraryPolicy = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLibraryPolicyData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateLibraryPolicyResponses,
    UpdateLibraryPolicyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/policy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * CreateLibrary
 *
 * Create a new library. This operation supports a deep insert semantic and allows to create definitions under the new library as part of the same operation.
 */
export const createLibrary = <ThrowOnError extends boolean = false>(
  options: Options<CreateLibraryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateLibraryResponses,
    CreateLibraryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * DeleteLibrary
 *
 * Mark library with given id as deleted. A resource is not deleted from the system but marked as deleted. All data is preserved. The version of the resource is incremented. Most of the other operations will refuse to work with items marked as deleted unless the 'deleted' query parameter is specified. A resource can be undeleted with PATCH operation.
 */
export const deleteLibrary = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLibraryData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteLibraryResponses,
    DeleteLibraryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}',
    ...options,
  });

/**
 * GetLibrary
 *
 * Get information about library with given id.
 */
export const getLibrary = <ThrowOnError extends boolean = false>(
  options: Options<GetLibraryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLibraryResponses,
    GetLibraryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}',
    ...options,
  });

/**
 * UpsertLibrary
 *
 * Update or create a library resource with given id. This operation will undelete the library resource if it exists and was marked as deleted. The existing resource version is incremented. To ensure that this request is not treated as an insert and be executed as an update, the client MAY specifies an `If-Match` header. To ensure that this request is not treated as an update and be executed as insert, the client MAY specify an `If-None-Match` header with a value of `*`.
 */
export const upsertLibrary = <ThrowOnError extends boolean = false>(
  options: Options<UpsertLibraryData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpsertLibraryResponses,
    UpsertLibraryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * ListDefinitions
 *
 * The pset definitions user has access to are returned in pages. A single operation will read up to the maximum number of items set (if using the top parameter) or a maximum of 500 KB of data and then apply any filtering to the results. If `next` is present in the response, you will need to paginate the result set. Note. A `ListDefinitions` operation can return an empty result set and a `next` if all the items read for the page of results are filtered out.
 */
export const listDefinitions = <ThrowOnError extends boolean = false>(
  options: Options<ListDefinitionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListDefinitionsResponses,
    ListDefinitionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs',
    ...options,
  });

/**
 * CreateDefinition
 *
 * Create a new pset definition.
 */
export const createDefinition = <ThrowOnError extends boolean = false>(
  options: Options<CreateDefinitionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateDefinitionResponses,
    CreateDefinitionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * DeleteDefinition
 *
 * Mark pset definition with given id as deleted. A resource is not deleted from the system but marked as deleted. All data is preserved. The version of the resource is incremented. Most of the other operations will refuse to work with items marked as deleted unless the 'deleted' query parameter is specified. A resource can be undeleted with PATCH operation.
 */
export const deleteDefinition = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDefinitionData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteDefinitionResponses,
    DeleteDefinitionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}',
    ...options,
  });

/**
 * GetDefinition
 *
 * Get information about pset definition with given id.
 */
export const getDefinition = <ThrowOnError extends boolean = false>(
  options: Options<GetDefinitionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDefinitionResponses,
    GetDefinitionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}',
    ...options,
  });

/**
 * UpsertDefinition
 *
 * Update pset definition resource with given id. This operation will undelete the pset definition resource if it exists and was marked as deleted. The existing resource version is incremented. The schema resource is incremented if and only if the schema property is present in the request body. To ensure that this request is not treated as an insert and be executed as an update, the client MAY specifies an `If-Match` header. To ensure that this request is not treated as an update and be executed as insert, the client MAY specify an `If-None-Match` header with the value of `*`.
 */
export const upsertDefinition = <ThrowOnError extends boolean = false>(
  options: Options<UpsertDefinitionData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpsertDefinitionResponses,
    UpsertDefinitionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Lists PSets by a pset library.
 *
 * Lists the non-deleted psets by a pset library the current user has access to. A single operation will read up to the maximum number of items set (if using the top parameter) or a maximum of 500 KB of data and then apply any filtering to the results. If `next` is present in the response, it indicates more psets might be available and can be fetched using the link in the `next` property. To fetch full set of psets keep fetching the `next` pages until the response returned does not contain the `next` property. Note, a `ListPSetsByLib` operation can return an empty result set and a `next` if all the items read for the page of results are filtered out.
 *
 * The `changeToken` returned with each page can be used to call the [ListChanges](#/PSets/ListPSetChangesByLib) API and fetch all the changes that has happened after the last pset returned on this page. Typically the `changeToken` returned on the last page is used to monitor for changes.
 */
export const listPSetsByLib = <ThrowOnError extends boolean = false>(
  options: Options<ListPSetsByLibData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPSetsByLibResponses,
    ListPSetsByLibErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/psets',
    ...options,
  });

/**
 * Lists PSets by a pset definition.
 *
 * The psets current user has access to by query (e.g. by a pset definition) in pages. A single operation will read up to the maximum number of items set (if using the top parameter) or a maximum of 500 KB of data and then apply any filtering to the results. If `next` is present in the response, you will need to paginate the result set. Note, a `ListPSetsByDef` operation can return an empty result set and a `next` if all the items read for the page of results are filtered out. Client have to iterate until `next` property in the response is not present.
 *
 * For initial synchronization in definition scope query parameter `sortBy=modifiedAt` must be used. In that case page of responses also contains cursor (known as `changeToken`) of the latest information returned so that later [ListPSetChangesByDef](#/PSets/ListPSetChangesByDef) can return changed psets only.
 */
export const listPSetsByDef = <ThrowOnError extends boolean = false>(
  options: Options<ListPSetsByDefData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPSetsByDefResponses,
    ListPSetsByDefErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}/psets',
    ...options,
  });

/**
 * BatchGetDefinitions
 *
 * Batch get pset definitions by listing definition identities in request. A single operation can retrieve up to 16MB of data, but max 100 items in one request. The operation returns a partial result if the response size limit is exceeded or an internal processing failure occurs. If a partial result is returned, the operation returns a value for `unprocessed` property in the response. You can use this value to retry the operation starting with the next item to get.
 * Important. If the service returns any unprocessed items, you should retry the batch operation on those items. However, we strongly recommend that you use an exponential backoff algorithm with jitter. If you retry the batch operation immediately, the underlying read or write requests can still fail due to throttling. If you delay the batch operation using exponential backoff, the individual requests in the batch are much more likely to succeed.
 * To minimize response latency, `BatchGetDefinitions` retrieves items in parallel. When designing your application, keep in mind that service does not return items in any particular order. If a requested item does not exist, it is not returned in the result (no errors will be returned).
 * This API is a variation of a more generic /batch-get API. The libId given in the YRL acts as a default value for the definition of identity if this property is not specified explicitly in the request body.
 *
 * @deprecated
 */
export const batchGetDefinitions = <ThrowOnError extends boolean = false>(
  options: Options<BatchGetDefinitionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchGetDefinitionsResponses,
    BatchGetDefinitionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/batch-get',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * ListDefinitionVersions
 *
 * Returns the collection of versions for the given pset definition.
 */
export const listDefinitionVersions = <ThrowOnError extends boolean = false>(
  options: Options<ListDefinitionVersionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListDefinitionVersionsResponses,
    ListDefinitionVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}/versions',
    ...options,
  });

/**
 * ValidatePsets
 *
 * Validates existing psets against the proposed definition schema and returns number of valid and invalid instances. Depending on the amount of existing data this API might take a long time to execute, so partial result might be returned with a link to the next page that allows resuming the validation for the next portion of the existing data. Requires `pset:ValidatePSets` permission.
 */
export const validatePsets = <ThrowOnError extends boolean = false>(
  options: Options<ValidatePsetsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ValidatePsetsResponses,
    ValidatePsetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * GetDefinitionVersion
 *
 * Returns specific version for the given pset definition. Requested version if exists always returned even if resource is marked as deleted.
 */
export const getDefinitionVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetDefinitionVersionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDefinitionVersionResponses,
    GetDefinitionVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}/versions/{ver}',
    ...options,
  });

/**
 * GetDefinitionVersionBySchema
 *
 * Returns the pset definition version for that has a given schema version. If several pset definition versions refer to the same schema version the latest resource version is returned.
 */
export const getDefinitionVersionBySchema = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDefinitionVersionBySchemaData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDefinitionVersionBySchemaResponses,
    GetDefinitionVersionBySchemaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}/schema/{ver}',
    ...options,
  });

/**
 * BatchGet
 *
 * Batch get resources (libs, defs, psets) by list of identities. A single operation can retrieve up to 16MB of data, but max 100 items in one request. The operation returns a partial result if the response size limit is exceeded or an internal processing failure occurs. If a partial result is returned, the operation returns a value for `unprocessed` property in the response. You can use this value to retry the operation starting with the next item to get.
 * Important. If the service returns any unprocessed items, you should retry the batch operation on those items. However, we strongly recommend that you use an exponential backoff algorithm with jitter. If you retry the batch operation immediately, the underlying read or write requests can still fail due to throttling. If you delay the batch operation using exponential backoff, the individual requests in the batch are much more likely to succeed.
 * To minimize response latency, `BatchGet` retrieves items in parallel. When designing your application, keep in mind that service does not return items in any particular order. If a requested item does not exist, it is not returned in the result (no errors will be returned).
 */
export const batchGet = <ThrowOnError extends boolean = false>(
  options: Options<BatchGetData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchGetResponses,
    BatchGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/batch-get',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * ListPSets
 *
 * The psets current user has access to by for a given pset definition in pages. A single operation will read up to the maximum number of items set (if using the top parameter) or a maximum of 500 KB of data and then apply any filtering to the results. If `next` is present in the response, you will need to paginate the result set. Note, a `ListPSets` operation can return an empty result set and a `next` if all the items read for the page of results are filtered out. Client have to iterate until `next` property in the response is not present.
 *
 * @deprecated
 */
export const listPSetsOld = <ThrowOnError extends boolean = false>(
  options: Options<ListPSetsOldData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPSetsOldResponses,
    ListPSetsOldErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets',
    ...options,
  });

/**
 * BatchGetPSets
 *
 * Batch get pset instances by listing pset identities in the request. A single operation cat retrieve up to 16MB of data, but max 100 items in one request. The operation returns a partial result if the response size limit is exceeded or an internal processing failure occurs. If a partial result is returned, the operation returns a value for `unprocessed` property in the response. You can use this value to retry the operation starting with the next item to get.
 * Important. If the service returns any unprocessed items, you should retry the batch operation on those items. However, we strongly recommend that you use an exponential backoff algorithm with jitter. If you retry the batch operation immediately, the underlying read or write requests can still fail due to throttling. If you delay the batch operation using exponential backoff, the individual requests in the batch are much more likely to succeed.
 * To minimize response latency, `BatchGetPSets` retrieves items in parallel. When designing your application, keep in mind that service does not return items in any particular order. If a requested item does not exist, it is not returned in the result (no errors will be returned).
 *
 * @deprecated
 */
export const batchGetPSets = <ThrowOnError extends boolean = false>(
  options: Options<BatchGetPSetsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchGetPSetsResponses,
    BatchGetPSetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/batch-get',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * BatchGetPSetsByDef
 *
 * Batch get pset instances of given pset definition (lib, def) by list of links in json body. A single operation cat retrieve up to 16MB of data, but max 100 items in one request. The operation returns a partial result if the response size limit is exceeded or an internal processing failure occurs. If a partial result is returned, the operation returns a value for `unprocessed` property in the response. You can use this value to retry the operation starting with the next item to get.
 * Important. If the service returns any unprocessed items, you should retry the batch operation on those items. However, we strongly recommend that you use an exponential backoff algorithm with jitter. If you retry the batch operation immediately, the underlying read or write requests can still fail due to throttling. If you delay the batch operation using exponential backoff, the individual requests in the batch are much more likely to succeed.
 * To minimize response latency, `BatchGetPSets` retrieves items in parallel. When designing your application, keep in mind that service does not return items in any particular order. If a requested item does not exist, it is not returned in the result (no errors will be returned).
 * This API is a variation of a more generic /batch-get API. The libId and defId gave in the URL act as a default value for the definition of identity if these properties are not specified explicitly in the request body.
 *
 * @deprecated
 */
export const batchGetPSetsByDef = <ThrowOnError extends boolean = false>(
  options: Options<BatchGetPSetsByDefData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchGetPSetsByDefResponses,
    BatchGetPSetsByDefErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/batch-get/{libId}/{defId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * ChangesetPSets
 *
 * Post changeset for processing. This operation allows sending a set of property set inserts/updates/deletes in a single request for efficient processing. The changeset is processed synchronously if the number of items in changeset less then or equal to 500. For large changesets, it returns 202 status code and processes the changeset asynchronously. The maximum body size is about 4MB, but already for changesets > 500KB, it is recommended (as a more efficient method) to use the asynchronous changeset API that allows us to initiate and upload the changeset content in streaming mode.
 */
export const changesetPSets = <ThrowOnError extends boolean = false>(
  options: Options<ChangesetPSetsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ChangesetPSetsResponses,
    ChangesetPSetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/changeset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * ChangesetPSetsAsync
 *
 * Initialize a changeset and get a link for uploading changeset content for later processing.
 * This operation allows sending a set of property set inserts/updates/deletes in a single request.
 * A link is provided for uploading the actual changeset content. Use PUT with that link to upload content. No additional
 * HTTP headers to be sent other than Content-Type.
 * This async variation of the changeset API allows us to work with really large changeset (up to 5GB) uploaded in streaming mode.
 * The changeset content must be uploaded in Newline Delimited JSON format (see http://ndjson.org/, Content-Type=application/x-ndjson).
 * Example of the changeset content to be uploaded (a json formatted resource per line)
 * ```json
 * { "link": "frn:foo1", "libId": "123", "defId": "xyz", "props": { "prop1": 88, "prop2": "Darth" } }
 * { "link": "frn:foo1", "libId": "4", "defId": "www", "props": { "progressPercentage": 50, "status": "InProgress" } }
 * { "link": "frn:foo3", "libId": "123", "defId": "xyz", "props": { "prop1": 100, "prop2": "Green" } }
 * ```
 * The changeset is queued for processing and the status of the processing can be requested by the "Get changeset status" operation.
 * When processing is done, also a link to download possible processing errors is returned with the status.
 * The error handling strategy is to continue on the error and return a list of errors that happened.
 */
export const changesetPSetsAsync = <ThrowOnError extends boolean = false>(
  options?: Options<ChangesetPSetsAsyncData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ChangesetPSetsAsyncResponses,
    ChangesetPSetsAsyncErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/changeset-async',
    ...options,
  });

/**
 * GetChangesetStatus
 *
 * Get changeset status.
 */
export const getChangesetStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetChangesetStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetChangesetStatusResponses,
    GetChangesetStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/changeset/{cSetId}',
    ...options,
  });

/**
 * Lists PSets attached to a given link.
 *
 * List pset instances attached to a given link. This API search psets across all definitions and libraries.
 */
export const listPsetsByLink = <ThrowOnError extends boolean = false>(
  options: Options<ListPsetsByLinkData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPsetsByLinkResponses,
    ListPsetsByLinkErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/{link}',
    ...options,
  });

/**
 * DeletePSet
 *
 * Mark pset for given external entity as deleted. The resource is not deleted from the system but marked as deleted. All data is preserved. The version of the resource is incremented. Most of the other operations will refuse to work with items marked as deleted unless the 'deleted' query parameter is specified. The resource can be undeleted with PATCH operation.
 */
export const deletePSet = <ThrowOnError extends boolean = false>(
  options: Options<DeletePSetData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePSetResponses,
    DeletePSetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/{link}/{libId}/{defId}',
    ...options,
  });

/**
 * GetPSet
 *
 * Get the pset.
 */
export const getPSet = <ThrowOnError extends boolean = false>(
  options: Options<GetPSetData, ThrowOnError>
) =>
  (options.client ?? client).get<GetPSetResponses, GetPSetErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/psets/{link}/{libId}/{defId}',
      ...options,
    }
  );

/**
 * UpdatePSet
 *
 * Create or update pset for given external resource with upsert semantic. If pset did exist, the entity version is incremented. If the version is given in the payload or the `If-Match` header then the operation is executed with update semantic. If a negative version is given in the payload or the `If-None-Match&#58; *` header is present then the operation is executed with insert semantic. This operation will undelete the pset definition if it was marked as deleted.
 */
export const updatePSet = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePSetData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdatePSetResponses,
    UpdatePSetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/{link}/{libId}/{defId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * ListPSetVersions
 *
 * Returns the collection of versions for the given pset.
 */
export const listPSetVersions = <ThrowOnError extends boolean = false>(
  options: Options<ListPSetVersionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPSetVersionsResponses,
    ListPSetVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/{link}/{libId}/{defId}/versions',
    ...options,
  });

/**
 * GetPSetVersion
 *
 * Returns specific version for the given pset. Requested version is returned even if resource is marked as deleted.
 */
export const getPSetVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetPSetVersionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPSetVersionResponses,
    GetPSetVersionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/psets/{link}/{libId}/{defId}/versions/{ver}',
    ...options,
  });

/**
 * PsetsSync - lists PSets and returns changeToken for getting later changes fast.
 *
 * PsetsSync is similar to [ListPSetsByDef](#/PSets/ListPSetsByDef) as PsetsSync also returns a paginated list of PSets. PsetsSync is meant to be used for initial state synchronization to support other syncing methods. There are two changes compared to ListPSetsByDef:
 *
 * 1.Only non-deleted psets can be fetched.
 *
 * 2.Each page of responses also contains cursor (known as *changeToken*) of the latest information returned so that later [fetch of changes](#/PSets%20Syncing%20BETA/ListChangedPSets) can return changed pSets only.
 *
 * If the multi-page response is interrupted the changeToken in the last page received can be used for later [fetch of changes](#/PSets%20Syncing%20BETA/ListChangedPSets) without having to complete the initial fetch successfully.
 *
 * @deprecated
 */
export const psetsSync = <ThrowOnError extends boolean = false>(
  options: Options<PsetsSyncData, ThrowOnError>
) =>
  (options.client ?? client).get<
    PsetsSyncResponses,
    PsetsSyncErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}/psetsSync',
    ...options,
  });

/**
 * Fetches changes in PSets by library
 *
 * Lists the psets that have been changed in the library at or after the given 'changeToken', including deleted psets. The first 'changeToken' must be gotten from [ListPSetsByLib](#/PSets/ListPSetsByLib).
 */
export const listPSetChangesByLib = <ThrowOnError extends boolean = false>(
  options: Options<ListPSetChangesByLibData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPSetChangesByLibResponses,
    ListPSetChangesByLibErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/changes',
    ...options,
  });

/**
 * Fetches changes in PSets by definition
 *
 * Gets the psets related to specific definition that are changed at or after the given 'changeToken'. Deleted psets are included, too. The first 'changeToken' must be gotten from [ListPSetsByDef](#/PSets/ListPSetsByDef).
 */
export const listPSetChangesByDef = <ThrowOnError extends boolean = false>(
  options: Options<ListPSetChangesByDefData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPSetChangesByDefResponses,
    ListPSetChangesByDefErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/libs/{libId}/defs/{defId}/changes',
    ...options,
  });
